import { UrlConstants } from "../url.constants";
export class ApiPropertyValuationCalculations {
    static URL = UrlConstants.API_V2 + "PropertyValuationCalculations";
    static FUNCTION_GET_VALUATIONS = "GetValuations";
    static FUNCTION_GET_AVERAGE_SALES = "GetAverageSales";
    static FUNCTION_GET_IS_CALCULATION_RUNNING = "GetIsCalculationRunning";
    static FUNCTION_START_ALL_VALUATION_CALCULATIONS = "StartAllValuationCalculations";
}
